export default __webpack_public_path__ + "static/media/w1.f6303f9b.png";